import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col, Card, Button } from 'react-bootstrap';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { DashboardOutlined } from '@material-ui/icons';
import ListingMarginMarketingPlan from 'components/ListingMarginMarketingPlan';
import MasterPage from 'components/MasterPage';
import { api } from 'services';
import ReactDOMServer from 'react-dom/server';
import convertToAscii from 'helpers/ConvertToASCII';
const MarginMarketingPlan = () => {
  const defaultFilters = {
    search: '',
    per_page: 10,
    page: 1,
    vendor: '',
    fiscal_year: '',
    period: '',
  };
  const [filters, setFilters] = useState(defaultFilters);
  const [reports, setReports] = useState({
    data: [],
    vendor: []
  });
  const [fiscalYears, setFiscalYears] = useState([]);
  const [periodTypes, setPeriodTypes] = useState([]);
  const [isExport, setExport] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    api
      .get('marketing-plan-action', { params: { ...filters } })
      .then(({ data }) => setReports(data));

    api
      .get('company-rules/fiscal-years')
      .then(({ data }) => setFiscalYears(data));

    api.get('period-types').then(({ data }) => setPeriodTypes(data));

  }, [filters]);

  const handleFilterChange = (new_filters, reset = false) => {
    let f = { ...filters, ...new_filters };

    if (reset) f = { ...defaultFilters, ...new_filters };

    setFilters(f);
  };

  const getPeriod = data => {
    var period = data.company_rule.period;
    var name = period.type.name;

    return name + ' ' + period.position;
  };

  const exportar = () => {
    setExport(true);
    let filters_aux = { ...filters };
    delete filters_aux.per_page;
    delete filters_aux.page;
    api.get('marketing-plan-action', {
      params: { ...filters_aux },
    }).then((data) => {
      function getActions(actions) {
        let teste2 = [];
        actions.map(action => {
          let detail = {
            id: action.id,
            task: action.task != null ? action.task.name : '--',
            value: action.margin.value.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL'
            }),
            expire: action.margin.expire.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL'
            }),
            gasto: action.margin.expense.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL'
            }),
            margin: action.margin.margin.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL'
            }),
          };
          teste2.push(detail);
        });
        return teste2;
      }
      let Data2 = [];
      Object.values(data.data.data).map((action, k) => {
        Data2.push({
          id: action.id,
          task: action.task != null ? action.task.name : '--',
          value: action.margin.value.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
          }),
          expire: action.margin.expire.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
          }),
          gasto: action.margin.expense.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
          }),
          margin: action.margin.margin.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
          }),
        });
      });
      var a = document.createElement('a');
      var data_type = 'data:application/vnd.ms-excel; charset=UTF-8';
      var table_div = (
        <table className="table table-bordered " border='1'>
          <thead>
            <tr>
              <th>ID</th>
              <th>Nome do Plano</th>
              <th>Vendor</th>
              <th>Periodo</th>
              <th>Ano Fiscal</th>
              <th>Margem</th>
            </tr>
          </thead>
          <tbody>
            {Object.values(data.data.data).map(report => {
              var item = {
                id: report.id,
                name: report.name,
                company_name: report.company.name + ' / ' + report.company.alias,
                year: report.company.fiscal_year,
                periodo: getPeriod(report),
                margin: report.margin.margin,
                actions: getActions(report.actions)
              }
              return (
                <>
                  <tr>
                    <td>{item.id}</td>
                    <td>{item.name}</td>
                    <td>{item.company_name}</td>
                    <td>{item.periodo}</td>
                    <td>{item.year}</td>
                    <td>{item.margin}</td>
                  </tr>
                  <tr><td colSpan="6">
                    <table border='1'>
                      <thead>
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">Categoria</th>
                          <th scope="col">Valor</th>
                          <th scope="col">Gasto</th>
                          <th scope="col">Verba Expirada</th>
                          <th scope="col">Margem</th>
                        </tr>
                      </thead>
                      <tbody>
                        {item.actions.map(action => {
                          return (
                            <tr>
                              <td>
                                {action.id}
                              </td>
                              <td>
                                {action.task}
                              </td>
                              <td>
                                {action.value}
                              </td>
                              <td>
                                {action.gasto}
                              </td>
                              <td>
                                {action.expire}
                              </td>
                              <td>
                                {(action.margin)}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </td>
                  </tr>
                  <tr><td></td></tr>
                </>
              );
            })}
          </tbody>
        </table>
      );

      table_div = (`
        <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
        <head>
          <!--[if gte mso 9]>
            <xml>
              <x:ExcelWorkbook>
                  <x:ExcelWorksheets>
                    <x:ExcelWorksheet>
                        <x:Name>{worksheet}</x:Name>
                        <x:WorksheetOptions>
                          <x:DisplayGridlines/>
                        </x:WorksheetOptions>
                    </x:ExcelWorksheet>
                  </x:ExcelWorksheets>
              </x:ExcelWorkbook>
            </xml>
          <![endif]-->
          <meta http-equiv="content-type" content="text/plain; charset=UTF-8"/>
        </head>
        <body>
          ${convertToAscii(ReactDOMServer.renderToString(table_div), [160])}
        </body>
      </html>`
      );

      var table_html = escape(table_div);
      a.href = data_type + ', ' + table_html;
      a.download = 'Report Marketing Plan.xls';
      a.click();
      setExport(false);
    });
  };

  return (
    <>
      <Card.Body className="shadow bg-white rounded mb-3">
        <Row>
          <Col className="d-flex mt-3 mb-3">
            <DashboardOutlined className="icon-title" />
            <h4 className="title-dashboard mt-2">Margem Por Plano de Marketing</h4>
          </Col>
        </Row>
        <Row className="mt-2">
          <Col>
            <Row>
              <Col>
                <Button disabled={isExport} onClick={exportar}>{t('label:export')}</Button>
              </Col>
            </Row>
            <Row className="mt-5">
              <Col>
                <ListingMarginMarketingPlan
                  reports={reports}
                  filters={[
                    {
                      name: 'fiscal year',
                      key: 'fiscal_year',
                      options: fiscalYears.map(({ fiscal_year }) => {
                        return { label: fiscal_year, value: fiscal_year };
                      }),
                    },
                    {
                      name: 'period',
                      key: 'period',
                      options: (() => {
                        const will_return = [];

                        periodTypes.forEach((periodType) => {
                          periodType.periods.forEach((period) => {
                            will_return.push({
                              label: `${periodType.name} ${period.position}`,
                              value: `${periodType.name} ${period.position}`,
                            });
                          });
                        });

                        return will_return;
                      })(),
                    },
                  ]}
                  stateFilters={filters}
                  setFilters={setFilters}
                  handleFilterChange={handleFilterChange}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Card.Body>
    </>
  );
};

export default MasterPage(MarginMarketingPlan);
